import React from "react";
import { Link } from "react-router-dom";
import Essimg from "../Assest/images/trading/sub-banner-5.jpg";
import Essimg1 from "../Assest/images/trading/sub-banner-6.jpg";

const TitanEyeplusHome = () => {
  return (
    <section className="service-section">
      <div className="featured-header">
        <div className="featured-header-inner">
          <h2 className="featured-title">Shop Essentials</h2>
        </div>
      </div>

      <div className="container">
        <div className="row">
          
          {/* LEFT IMAGE */}
          <div className="col-lg-6 mb-4">
            <div className="Essentials-box">
              <img src={Essimg} className="w-100" alt="Eyewear" />

              <div className="essentials-content">
                <span className="tag">New Collection</span>
                <h3>Stylish Sunglasses</h3>
                <p>Protect your eyes with premium UV lenses</p>

                {/* ✅ FIXED LINK */}
                <Link
                  to="/category?type=eyeglasses"
                  className="shop-btn"
                >
                  Shop Now
                </Link>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 mb-4">
            <div className="Essentials-box">
              <img src={Essimg1} className="w-100" alt="Power Glasses" />

              <div className="essentials-content">
                <span className="tag">Best Seller</span>
                <h3>Power Glasses</h3>
                <p>Clear vision for everyday comfort</p>

                {/* ✅ FIXED LINK */}
                <Link
                  to="/category?type=power-sunglasses"
                  className="shop-btn"
                >
                  Explore
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TitanEyeplusHome;
